import CategoryResult from 'generated/Result/CategoryClientContent/CategoryResult';
import { GET_HOME_CONTENT, GET_CATEGORY_CLIENTCONTENT, UNAUTH_USER } from '../types/content';
import { PayloadAction, RESET_STATE } from '../types/global';

export interface ContentState {
  homeContent: any,
  anonymousCategoryClientContent: CategoryResult[],
  categoryClientContent: CategoryResult[]
}

// These client content values are hard-coded here because they are available to anonymous users,
// unlike those found and used in cur.ClientContent.
const INITIAL_STATE = {
  homeContent: null,
  anonymousCategoryClientContent: [{
    category: 'login-page',
    clientContent: [
      {
        token: 'user-name',
        text: 'Username',
      },
      {
        token: 'password',
        text: 'Password',
      },
      {
        token: 'login-button',
        text: 'Login',
      },
      {
        token: 'forgot-password-button',
        text: 'Forgot Password',
      },
      {
        token: 'register-button',
        text: 'Register'
      }
    ],
  }, {
    category: 'multifactor-modal',
    clientContent: [
      {
        token: 'selection-message',
        text: 'Choose an authentication below to use for multifactor authentication.',
      },
      {
        token: 'change-alert-message',
        text: 'If you wish to change your authentication type, please contact the OMMU.',
      },
      {
        token: 'save',
        text: 'Save',
      },
      {
        token: 'go-back',
        text: 'Go Back',
      }
    ],
  },
  {
    category: 'multifactor-authentication',
    clientContent: [
      {
        token: 'multifactor-authentication-heading',
        text: 'Multifactor Authentication',
      },
      {
        token: 'multifactor-authentication-selection',
        text: 'Choose an authentication method below to use for multifactor authentication.',
      },
      {
        token: 'multifactor-authentication-selection-save',
        text: 'Save',
      },
      {
        token: 'multifactor-authentication-selection-go-back',
        text: 'Go Back',
      },
      {
        token: 'multifactor-authentication-mfa-authenticator-app',
        text: 'Please enter the six-digit code below:',
      },
      {
        token: 'multifactor-authentication-mfa-authenticator-app-validate',
        text: 'Validate',
      },
      {
        token: 'multifactor-authentication-mfa-email',
        text: 'Please enter the six-digit code below:',
      },
      {
        token: 'multifactor-authentication-mfa-email-validate',
        text: 'Validate',
      },
      {
        token: 'multifactor-authentication-mfa-email-resend',
        text: 'Resend Code',
      },
    ],
  },
  {
    category: 'forgot-password-page',
    clientContent: [
      {
        token: 'login-id',
        text: 'Username',
      },
      {
        token: 'forgot-password-button',
        text: 'Submit',
      },
      {
        token: 'go-back-to-login',
        text: 'Go Back to Login',
      },
    ],
  },
  {
    category: 'change-password',
    clientContent: [
      {
        token: 'change-password-heading',
        text: 'Change Password',
      },
      {
        token: 'new-password',
        text: 'New Password',
      },
      {
        token: 'confirm-new-password',
        text: 'Confirm New Password',
      },
      {
        token: 'change-password-button',
        text: 'Submit',
      },
      {
        token: 'password-requirements-heading',
        text: 'Password must meet the following requirements',
      },
      {
        token: 'contains-a-lowercase-letter',
        text: 'Contains a lowercase letter',
      },
      {
        token: 'contains-an-uppercase-letter',
        text: 'Contains an uppercase letter',
      },
      {
        token: 'contains-a-special-character',
        text: 'Contains a special character',
      },
      {
        token: 'contains-a-number',
        text: 'Contains a number',
      },
      {
        token: 'contains-minimum-characters',
        text: 'Contains at least 12 characters',
      },
      {
        token: 'contains-no-spaces',
        text: 'Contains no spaces',
      },
      {
        token: 'contains-no-spaces',
        text: 'Contains no spaces',
      },
      {
        token: 'confirm-new-password-match-new-password',
        text: 'Confirm New Password must match with New Password',
      }
    ],
  },
  {
    category: 'register',
    clientContent: [
      {
        token: 'registration-no-match-found',
        text: 'We did not find a match.\n\nPlease check the information supplied and try again. Remember, we are  checking license profile with the Department of Health.\n\nIf you are sure this information is correct, contact the Office of Medical Marijuana Use.'
      },
      {
        token: 'registration-existing-physician',
        text: 'This Physician\'s information is already in the Registry.\n\nIf you are trying to gain access to your account, go back and request a password reset.\n\nIf you cannot gain access to your account, or are having another issue, contact the Office of Medical Marijuana Use.'
      },
      {
        token: 'registration-existing-director',
        text: 'The physician with medical license number {LicenseNumber} is a Medical Director for a medical marijuana treatment center.\n\nPer 381.986(3)(b), Florida Statutes, a qualified physician may not be employed by, or have any direct or indirect economic interest in, a medical marijuana treatment center or marijuana testing laboratory.'
      },
      {
        token: 'registration-too-many-attempts',
        text: 'Sorry, but we did not find a match. You have exceeded the allowable attempts for licensed number {LicenseNumber}. This number is suspended until {FailedRegistrationTryAgainDateString}.'
      },
      {
        token: 'registration-found',
        text: 'A match was found. Please supply the following information to complete your registration:'
      },
      {
        token: 'registration-complete',
        text: 'You have been sent a temporary password to {PhysicianUserEmailAddress}. Be on the lookout for an email from the Medical Marijuana User Registry, in case your spam filter catches it.\n\nIf you do not receive it in the next few minutes, you may always reset your password at the login page by using the Forgot Password button.'
      },
      {
        token: 'captcha-value-too-low',
        text: 'The captcha value for the request was too low. Please fill out the captcha again.'
      }
    ]
  },
  {
    category: 'physician',
    clientContent: [
      {
        token: 'mqa-check-profession',
        text: 'Your Profession'
      },
      {
        token: 'mqa-check-license-number',
        text: 'License Number'
      },
      {
        token: 'mqa-check-first-name',
        text: 'First Name'
      },
      {
        token: 'mqa-check-last-name',
        text: 'Last Name'
      },
      {
        token: 'mqa-check-dob',
        text: 'Date of Birth (mm/dd/yyyy)'
      },
      {
        token: 'mqa-check-last-four-ssn',
        text: 'Last Four Digits of SSN'
      },
      {
        token: 'mqa-check-justification',
        text: 'Justification'
      },
      {
        token: 'register-login-id',
        text: 'Login ID'
      },
      {
        token: 'register-email-address',
        text: 'Email Address'
      }
    ]
  }
  ],

  categoryClientContent: undefined
} as unknown as ContentState;

const contentReducer = (state: ContentState = INITIAL_STATE, action: PayloadAction<any>): ContentState => {
  switch (action.type) {
    case RESET_STATE:
    case UNAUTH_USER:
      return INITIAL_STATE;
    case GET_HOME_CONTENT:
      return { ...state, homeContent: action.payload };
    case GET_CATEGORY_CLIENTCONTENT:
      return { ...state, categoryClientContent: action.payload };
    default:
      return state;
  }
};

export default contentReducer;
